@if (isLoader) {
  <div class="d-flex justify-content-center">
    <app-loader size="small"></app-loader>
  </div>
} @else {
  <!-- TablePagination -->
  @if (showUpPagination && dataSource?.rows?.length) {
    <table-pagination
      [length]="dataSource.length"
      [pageIndex]="dataSource.pageIndex"
      [pageSize]="dataSource.pageSize"
      [pageSizeOptions]="[25, 50, 75, 100]"
      dropdownPosition="bottom"
      (page)="onPagination($event)"
      class="mat-paginator-sticky"
    >
    </table-pagination>
  }
  <div class="app-table-box {{ customClass }}" tabindex="0">
    <div class="table-box crm-scroll">
      @if (dataSource) {
        <table
          class="text-short full-width-table"
          mat-table
          matSort
          [dataSource]="dataSource.rows"
          (matSortChange)="announceSortChange($event)"
        >
          @for (header of dataSource.headers; track header) {
            <ng-container [matColumnDef]="header.value">
              <th
                mat-header-cell
                *matHeaderCellDef
                disableClear
                mat-sort-header
                class="table-header-cell"
                [style.width]="header.width ? header.width + 'px' : 'auto'"
                [ngClass]="header.className"
                [disabled]="header.type === TableColumnTypes.CHECKBOX || header.name === '' || header.disabled"
                [sortActionDescription]="'Sort by ' + header.value"
              >
                @if (header.type === TableColumnTypes.CHECKBOX) {
                  <app-checkbox
                    [disableRipple]="true"
                    (change)="toggleAllRows()"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                  />
                }
                {{ header.translate && header.name ? (header.name | translate) : header.name }}
              </th>
              <!-- Text -->
              @if (header.type === TableColumnTypes.TEXT) {
                <td
                  #Text
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ row[header.value] }}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isEllipsisActive(Text) || baseService.isMobile"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  {{ row[header.value] ? row[header.value] : '-' }}
                </td>
              }
              <!-- Text -->
              @if (header.type === TableColumnTypes.TEXT_TRANSLATE) {
                <td
                  #Text
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ row[header.value] }}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isEllipsisActive(Text) || baseService.isMobile"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  {{ row[header.value] ? (row[header.value] | translate) : '-' }}
                </td>
              }
              <!-- Icon -->
              @if (header.type === TableColumnTypes.ICON) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  @if (row[header.value]?.icon) {
                    <app-icon
                      class="!text-[28px] !leading-7"
                      [ngClass]="row[header.value].className"
                      [matTooltip]="row[header.value].tooltip ? (row[header.value].tooltip | translate) : ''"
                      matTooltipPosition="above"
                    >
                      {{ row[header.value].icon }}
                    </app-icon>
                  } @else {
                    -
                  }
                </td>
              }
              <!-- Error Code -->
              @if (header.type === TableColumnTypes.ERROR_CODE) {
                <td
                  #Text
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{
                    (ERROR_MESSAGES_STRING[row[header.value]]
                      ? (ERROR_MESSAGES_STRING[row[header.value]] | translate)
                      : row[header.value]) ?? '-'
                  }}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isEllipsisActive(Text) || baseService.isMobile"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  {{
                    (ERROR_MESSAGES_STRING[row[header.value]]
                      ? (ERROR_MESSAGES_STRING[row[header.value]] | translate)
                      : row[header.value]) ?? '-'
                  }}
                </td>
              }
              <!-- Title -->
              @if (header.type === TableColumnTypes.TITLE) {
                <td
                  #Text
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ row[header.value] }}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isEllipsisActive(Text) || baseService.isMobile"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  @if (row.is_group) {
                    <app-icon class="logo" [isFlexBox]="false" matTooltip="{{ 'group' | translate }}">
                      ad_group
                    </app-icon>
                  }
                  @if (row.is_crm) {
                    <app-icon
                      class="logo"
                      [isFlexBox]="false"
                      matTooltip="{{ 'created_in_jecrm' | translate }}"
                      svgIcon="jecrm"
                    />
                  }
                  {{ row[header.value] ? row[header.value] : '-' }}
                </td>
              }
              <!-- Olx Price -->
              @if (header.type === TableColumnTypes.OLX_PRICE) {
                <td
                  #Text
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ row[header.value] | olxPrice }}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isEllipsisActive(Text) || baseService.isMobile"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  {{ row[header.value] ? (row[header.value] | olxPrice) : '-' }}
                </td>
              }
              <!-- Link -->
              @if (header.type === TableColumnTypes.LINK) {
                <td
                  #Text
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ row[header.value] }}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isEllipsisActive(Text) || baseService.isMobile"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  <a target="_blank" (click)="$event.stopPropagation()" [href]="row[header.value]">{{
                    row[header.value] ? row[header.value] : '-'
                  }}</a>
                </td>
              }
              <!-- Boolean -->
              @if (header.type === TableColumnTypes.BOOLEAN) {
                <td
                  #Text
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ row[header.value] }}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isEllipsisActive(Text) || baseService.isMobile"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  {{ row[header.value] ? 'yes' : ('no' | translate) }}
                </td>
              }
              <!-- Toggle -->
              @if (header.type === TableColumnTypes.TOGGLE) {
                <td mat-cell *matCellDef="let row">
                  <app-toggle
                    (click)="$event.stopPropagation()"
                    (change)="onChange($event, row)"
                    [checked]="row[header.value]"
                  ></app-toggle>
                </td>
              }
              <!-- Select -->
              @if (header.type === TableColumnTypes.SELECT) {
                <td mat-cell *matCellDef="let row">
                  <app-select
                    (click)="$event.stopPropagation()"
                    [options]="header.options || []"
                    [optionLabel]="header.optionLabel || 'name'"
                    [optionValue]="header.optionValue || 'id'"
                    [placeholder]="header.placeholder || '' | translate"
                    [filter]="true"
                    [showClear]="true"
                    [ngModel]="row[header.value]"
                    [ngModelOptions]="{ standalone: true }"
                    (valueChange)="onSelect($event, row, header)"
                  />
                </td>
              }
              <!-- Checkbox -->
              @if (header.type === TableColumnTypes.CHECKBOX) {
                <td class="table-checkbox" mat-cell *matCellDef="let row">
                  <app-checkbox
                    [disableRipple]="true"
                    (click)="$event.stopPropagation()"
                    (change)="onCheckRow(row)"
                    [checked]="selection.isSelected(row)"
                  />
                </td>
              }
              <!-- Date -->
              @if (header.type === TableColumnTypes.DATE) {
                <td
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ row[header.value] | date: 'dd/MM/yyyy HH:mm:ss' }}"
                  [matTooltipDisabled]="baseService.isMobile"
                  matTooltipPosition="above"
                >
                  {{ row[header.value] ? (row[header.value] | date: 'dd/MM/yyyy') : '-' }}
                </td>
              }
              <!-- Date time -->
              @if (header.type === TableColumnTypes.DATETIME) {
                <td
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ row[header.value] | date: 'dd/MM/yyyy HH:mm:ss' }}"
                  [matTooltipDisabled]="baseService.isMobile"
                  matTooltipPosition="above"
                >
                  {{ row[header.value] ? (row[header.value] | date: 'dd/MM/yyyy HH:mm:ss') : '-' }}
                </td>
              }
              <!-- Price -->
              @if (header.type === TableColumnTypes.PRICE) {
                <td
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  [matTooltip]="row[header.value]"
                  [matTooltipDisabled]="baseService.isMobile"
                  matTooltipPosition="above"
                >
                  {{ row[header.value] ? row[header.value] : '0' }}$
                </td>
              }
              <!-- Payment info -->
              @if (header.type === TableColumnTypes.PAYMENT_INFO) {
                <td
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ getPaymentInfo(row[header.value]) }}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="getPaymentInfo(row[header.value]) === '-' || baseService.isMobile"
                >
                  {{ getPaymentInfo(row[header.value]) }}
                </td>
              }
              <!-- Olx Status -->
              @if (header.type === TableColumnTypes.OLX_STATUS) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  @if (!row[header.value]) {
                    <app-icon style="color: red">cancel</app-icon>
                  }
                  @if (row[header.value] === 'EXPIRED') {
                    <app-icon style="color: orange">warning</app-icon>
                  }
                  @if (row[header.value] === 'ACTIVE') {
                    <app-icon style="color: green">check_circle</app-icon>
                  }
                  @if (row[header.value] === 'CLOSED') {
                    <app-icon style="color: orange">hourglass_empty</app-icon>
                  }
                  @if (row[header.value] === 'PAUSE') {
                    <app-icon style="color: orange">pause_circle</app-icon>
                  }
                </td>
              }
              @if (header.type === TableColumnTypes.MEMBERSHIP_STATUS) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  @if (MEMBERSHIP_STATUS_CHIPS[row[header.value]]; as chip) {
                    <app-tag
                      [tag]="{ id: row[header.value], name: chip.label | translate, color: chip.color }"
                      [icon]="chip.icon"
                      [maxCharacters]="24"
                    />
                  }
                </td>
              }
              @if (header.type === TableColumnTypes.PAYMENT_STATUS) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  @if (!row[header.value]) {
                    <app-icon style="color: red">cancel</app-icon>
                  }
                  @if (row[header.value] === PaymentStatus.TODO) {
                    <app-icon style="color: orange">schedule</app-icon>
                  }
                  @if (row[header.value] === PaymentStatus.CREATED) {
                    <app-icon style="color: blue">playlist_add</app-icon>
                  }
                  @if (row[header.value] === PaymentStatus.IN_PROCESS) {
                    <app-icon style="color: orange">hourglass_empty </app-icon>
                  }
                  @if (row[header.value] === PaymentStatus.SUCCESS) {
                    <app-icon style="color: green">check_circle </app-icon>
                  }
                </td>
              }
              <!-- Channel Status -->
              @if (header.type === TableColumnTypes.CHANNEL_STATUS) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  @if (row[header.value] === CHANNEL_STATUS.CREATED) {
                    <app-icon style="color: darkgrey">pending</app-icon>
                  }
                  @if (row[header.value] === CHANNEL_STATUS.CONNECTED) {
                    <app-icon style="color: green">check_circle </app-icon>
                  }
                  @if (row[header.value] === CHANNEL_STATUS.SYNCING) {
                    <app-icon style="color: green">sync</app-icon>
                  }
                  @if (row[header.value] === CHANNEL_STATUS.DISCONNECTED) {
                    <app-icon style="color: orange">warning </app-icon>
                  }
                  @if (row[header.value] === CHANNEL_STATUS.EXPIRED) {
                    <app-icon style="color: orange">hourglass_empty </app-icon>
                  }
                  @if (row[header.value] === CHANNEL_STATUS.PAUSED) {
                    <app-icon style="color: orange">pause_circle </app-icon>
                  }
                  @if (row[header.value] === CHANNEL_STATUS.CLOSED) {
                    <app-icon style="color: orange">cancel</app-icon>
                  }
                  @if (row[header.value] === CHANNEL_STATUS.PROCESSING) {
                    <app-icon style="color: green">sync</app-icon>
                  }
                </td>
              }
              <!-- Channel IMAGE -->
              @if (header.type === TableColumnTypes.CHANNEL_TYPE) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  @if (getChannelObject(row[header.value])) {
                    <img
                      [src]="$safeNavigationMigration(getChannelObject(row[header.value])?.img_url)"
                      class="icon-md rounded-circle"
                      [alt]="row[header.value].toLowerCase()"
                    />
                  } @else {
                    <img src="/assets/svgs/logos/jecrm.ico" class="icon-md rounded-circle" alt="unknown channel " />
                  }
                </td>
              }
              <!-- Olx Image -->
              @if (header.type === TableColumnTypes.OLX_IMAGE) {
                <td
                  class="table-image"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  [appPhotoGalleryGroup]="{ clickMode: 'single' }"
                >
                  @for (file of row[header.value]; track file; let i = $index) {
                    <img
                      class="grid-item"
                      [appPhotoGallery]="{ mimeType: 'image/png', url: file.url }"
                      (click)="$event.stopPropagation()"
                      [src]="file.url"
                      [ngClass]="{ 'd-none': i }"
                    />
                  }
                </td>
              }
              <!-- Delivery Waybill Column -->
              @if (header.type === TableColumnTypes.DELIVERY_WAYBILL) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  @if (OLX_DELIVERY_DEPARTMENTS_MAP[row.recipient_shipping_method]; as department) {
                    <div class="table-text-container">
                      <img [src]="department.logo" class="icon-xxm" />
                      @if (row.package_cheque_number) {
                        <a [href]="row.package_tracking_url" target="_blank">
                          {{ row.package_cheque_number }}
                        </a>
                      } @else {
                        {{ 'olx.delivery.other.to_department' | translate }}
                        {{ department.name | translate }}
                      }
                    </div>
                  }
                </td>
              }
              <!-- Planner V2 Status Column -->
              @if (header.type === TableColumnTypes.PLANNER_V2_STATUS) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  @if (getPlannerStatus(row[header.value]); as status) {
                    <div class="status">
                      <app-icon
                        [matTooltip]="status.text | translate"
                        matTooltipPosition="above"
                        [matTooltipDisabled]="baseService.isMobile"
                        [style.color]="status.color"
                      >
                        {{ status.icon }}
                      </app-icon>
                    </div>
                  }
                </td>
              }
              <!-- Power Olx Status Column -->
              @if (header.type === TableColumnTypes.POWER_OLX_STATUS) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  @if (getPowerOlxStatus(row); as status) {
                    <div class="status">
                      <app-icon
                        [matTooltip]="
                          row.tab_type === PowerOlxV2Tab.DELIVERIES ? status.text : (status.text | translate)
                        "
                        matTooltipPosition="above"
                        [matTooltipDisabled]="baseService.isMobile"
                        [style.color]="status.color"
                      >
                        {{ status.icon }}
                      </app-icon>
                    </div>
                  }
                </td>
              }
              <!-- Olx Advert Status -->
              @if (header.type === TableColumnTypes.OLX_ADVERT_STATUS) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  <div class="status">
                    <app-icon
                      [matTooltip]="status_table_olx_adverts(row[header.value]).text"
                      matTooltipPosition="above"
                      [matTooltipDisabled]="baseService.isMobile"
                      [style.color]="status_table_olx_adverts(row[header.value]).color"
                    >
                      {{ status_table_olx_adverts(row[header.value]).icon }}
                    </app-icon>
                  </div>
                </td>
              }
              <!-- Nova Poshta Status -->
              @if (header.type === TableColumnTypes.NOVA_POSHTA_STATUS) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  <div class="status">
                    <app-icon
                      [matTooltip]="status_table_nova_poshta(row[header.value]).text"
                      matTooltipPosition="above"
                      [matTooltipDisabled]="baseService.isMobile"
                      [style.color]="status_table_nova_poshta(row[header.value]).color"
                    >
                      {{ status_table_nova_poshta(row[header.value]).icon }}
                    </app-icon>
                  </div>
                </td>
              }
              <!-- UKR Poshta Status -->
              @if (header.type === TableColumnTypes.UKR_POSHTA_STATUS) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  <div class="status">
                    <app-icon
                      [matTooltip]="status_table_nova_poshta(row[header.value]).text"
                      matTooltipPosition="above"
                      [matTooltipDisabled]="baseService.isMobile"
                      [style.color]="status_table_nova_poshta(row[header.value]).color"
                    >
                      {{ status_table_nova_poshta(row[header.value]).icon }}
                    </app-icon>
                  </div>
                </td>
              }
              <!--  status novaposta   -->
              @if (header.type === TableColumnTypes.TEXT) {
                <td class="table-text"></td>
              }
              <!-- Planner Status -->
              @if (header.type === TableColumnTypes.PLANNER_STATUS) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  <div class="status">
                    <app-icon
                      [matTooltip]="status_table_planner(row[header.value]).text"
                      matTooltipPosition="above"
                      [matTooltipDisabled]="baseService.isMobile"
                      [style.color]="status_table_planner(row[header.value]).color"
                    >
                      {{ status_table_planner(row[header.value]).icon }}
                    </app-icon>
                  </div>
                </td>
              }
              <!-- Planner Type -->
              @if (header.type === TableColumnTypes.PLANNER_TYPE) {
                <td *matCellDef="let row" class="table-text" mat-cell (click)="cellClicked(row, header.value)">
                  {{ ADVERT_PLANNER_TYPE[row[header.value]] }}
                </td>
              }
              <!-- Audio         -->
              @if (header.type === TableColumnTypes.AUDIO) {
                <td
                  *matCellDef="let row"
                  class="table-text text-center"
                  mat-cell
                  (click)="cellClicked(row, header.value)"
                >
                  <app-button [disabled]="!row[header.value]" btnType="icon">
                    @if (row[header.value]) {
                      @if (audioService.isPlay && audioService.currentAudio === row[header.value]) {
                        <app-icon>pause </app-icon>
                      }
                      @if (
                        !audioService.isPlay || (audioService.isPlay && audioService.currentAudio !== row[header.value])
                      ) {
                        <app-icon> play_arrow </app-icon>
                      }
                    }
                  </app-button>
                  @if (!row[header.value]) {
                    <span class="me-5">{{ 'no_conversation' | translate }}</span>
                  }
                </td>
              }
              @if (header.type === TableColumnTypes.CALL) {
                <td
                  *matCellDef="let row"
                  class="table-text"
                  mat-cell
                  [matTooltip]="row[header.value].text"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="baseService.isMobile"
                >
                  @if (row[header.value] === 'out') {
                    <app-icon matTooltip="{{ 'outgoing' | translate }}">phone_forwarded </app-icon>
                  }
                  @if (row[header.value] === 'in') {
                    <app-icon matTooltip="{{ 'incoming' | translate }}">phone_callback </app-icon>
                  }
                </td>
              }
              <!-- phone-->
              @if (header.type === TableColumnTypes.PHONE) {
                <td
                  #Phone
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  {{ row[header.value] ? formatPhone(row[header.value]) : '-' }}
                </td>
              }
              <!-- Image -->
              @if (header.type === TableColumnTypes.AVATAR) {
                <td class="table-image" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  <app-avatar
                    size="45px"
                    [url]="row[header.value] || undefined"
                    [title]="header.titleKey ? row[header.titleKey] : undefined"
                    [status]="header.statusKey ? row[header.statusKey] : undefined"
                    [isPhotoGallery]="true"
                  />
                </td>
              }
              @if (header.type === TableColumnTypes.IMAGE) {
                <td
                  class="table-image"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  [appPhotoGalleryGroup]="{ clickMode: 'single' }"
                >
                  <img
                    class="grid-item {{ classImage }}"
                    [appPhotoGallery]="{ url: row[header.value], mimeType: 'image/png' }"
                    [src]="row[header.value]"
                  />
                </td>
              }
              <!-- array phone-->
              @if (header.type === TableColumnTypes.ARRAY_PHONE) {
                <td
                  #Phone
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  {{ row[header.value].length ? arrayFormat(row[header.value]) : '-' }}
                </td>
              }
              <!-- array-->
              @if (header.type === TableColumnTypes.ARRAY) {
                <td
                  #Text
                  class="table-text"
                  mat-cell
                  *matCellDef="let row"
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ row[header.value] }}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isEllipsisActive(Text) || baseService.isMobile"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  {{ row[header.value].length ? _filter(row[header.value]).join(', ') : '-' }}
                </td>
              }
              <!-- TEXT COPY-->
              @if (header.type === TableColumnTypes.TEXT_COPY) {
                <td
                  #TextCopy
                  *matCellDef="let row"
                  class="table-text position-relative"
                  mat-cell
                  (click)="cellClicked(row, header.value)"
                  matTooltip="{{ row[header.value] }}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isEllipsisActive(TextCopy) || baseService.isMobile"
                  [ngClass]="{ '': !row[header.value] }"
                >
                  @if (row[header.value]) {
                    <div
                      class="copy-row"
                      matTooltip="{{ 'copy' | translate }}"
                      matTooltipPosition="below"
                      [cdkCopyToClipboard]="row[header.value]"
                      [matTooltipDisabled]="baseService.isMobile"
                      (click)="onCopy($event, row[header.value])"
                      tabindex="-1"
                    >
                      <app-icon>content_copy</app-icon>
                    </div>
                  }
                  {{ row[header.value] ? row[header.value] : '-' }}
                </td>
              }
              <!-- Action -->
              @if (header.type === TableColumnTypes.ACTION) {
                <td class="text-right" mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                  @if (getActionList(actions, row).length) {
                    <app-button
                      [btnType]="'icon'"
                      [cdkMenuTriggerFor]="context_menu"
                      [cdkMenuTriggerData]="{ row: header.translate ? (row | translate) : row }"
                    >
                      <app-icon>more_vert</app-icon>
                    </app-button>
                  }
                </td>
              }
              <!--          time duration-->
              @if (header.type === TableColumnTypes.TIME) {
                <td class="table-text" mat-cell *matCellDef="let row" (click)="cellClicked(row, header.value)">
                  {{ millisecondsToTime(row[header.value]) }}
                </td>
              }
            </ng-container>
          }
          <ng-container matColumnDef="noRecord">
            <td class="no-results" mat-footer-cell [attr.colspan]="visibleColumnKeys.length" *matFooterCellDef>
              {{ 'nothing_found' | translate }}
            </td>
          </ng-container>
          <tr mat-header-row class="table-header" *matHeaderRowDef="visibleColumnKeys"></tr>
          <tr
            *matRowDef="let row; columns: visibleColumnKeys"
            mat-row
            class="table-row"
            [hidden]="!dataSource.rows.length"
            [cdkContextMenuTriggerFor]="context_menu"
            [cdkContextMenuTriggerData]="{ row: row }"
          ></tr>
          <tr
            mat-footer-row
            [hidden]="$safeNavigationMigration(dataSource?.rows?.length)"
            *matFooterRowDef="dataSource?.rows?.length ? [] : ['noRecord']"
          ></tr>
          <ng-template #context_menu let-row="row">
            <div cdkMenu class="menu">
              @for (item of getActionList(actions, row); track item; let i = $index) {
                <button
                  [disabled]="$safeNavigationMigration(item.disabled?.([row]))"
                  class="menu-item"
                  cdkMenuItem
                  (click)="menuOnSelect(row, item)"
                >
                  @if (item?.icon) {
                    <app-icon class="icon-color" [ngStyle]="{ '--icon-color': item.color_icon }">
                      {{ item.icon }}
                    </app-icon>
                  }
                  <span class="menu-title">{{ item.label | translate }}</span>
                </button>
              }
            </div>
          </ng-template>
        </table>
      }
    </div>
    <!-- TablePagination -->
  </div>
  <div>
    @if (showPagination && dataSource?.rows?.length) {
      <table-pagination
        [length]="dataSource.length"
        [pageIndex]="dataSource.pageIndex"
        [pageSize]="dataSource.pageSize"
        [pageSizeOptions]="[25, 50, 75, 100]"
        (page)="onPagination($event)"
        class="mat-paginator-sticky"
      >
      </table-pagination>
    }
  </div>
}
